import React, { useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";

import { ProductContext } from "../../data/product_context_management";

function AddSectionButton() {
  const { canAddSpecifications, setOpenEditModal } = useContext(ProductContext);

  if (!canAddSpecifications) return null;

  return (
    <Dropdown className="ms-2 align-self-center" style={{ width: "auto", maxHeight: "2rem" }}>
      {/* outline-secondary + sm on purpose: an owner-only utility on the name line, visibly
          subordinate to the header's public buttons. */}
      <Dropdown.Toggle variant="outline-secondary" size="sm">
        <i className="fa-solid fa-plus cursor-pointer" />
        &nbsp; Add a section
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => setOpenEditModal("SPECIFICATIONS")}>Specifications</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default AddSectionButton;
